import { Box, Chip, Typography } from "@mui/material";
import { HStack, colors } from "@zfp-akademie-a-s/zfp-design";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { TimelineAxisCell, TimelineContentCell, TimelineDateCell, TimelineRow } from "./TimelineRow";
import { formatMonthYear } from "./utils/dates";

export const TodayMarker = () => {
  const { t } = useResource();

  return (
    <TimelineRow height={48} alignItems="center">
      <TimelineDateCell>
        <Typography variant="body2" fontWeight={700} color="primary.main">
          {formatMonthYear(new Date())}
        </Typography>
      </TimelineDateCell>

      <TimelineAxisCell>
        <Box
          width={14}
          height={14}
          borderRadius={Radius.MAX}
          bgcolor="primary.main"
          sx={(theme) => ({ boxShadow: `0 0 0 4px ${theme.palette.primary.light}` })}
        />
      </TimelineAxisCell>

      <TimelineContentCell>
        <HStack alignItems="center" gap={Spacing.L}>
          <Chip size="small" color="primary" label={t(Resources.AnalysisDetail.Goals.Timeline.Today)} sx={{ flexShrink: 0 }} />
          <Box flex={1} borderTop={1} sx={{ borderColor: colors.brandLightBorder }} />
        </HStack>
      </TimelineContentCell>
    </TimelineRow>
  );
};
